import { EventSourceHandler } from '@sellsy/sse';

export default class ActivityEventSourceHandler extends EventSourceHandler {
    constructor() {
        super();
        this.type = 'corporation.activity';
    }

    handle(event) {
        EventBus.emit('sse:activity', event.data);
    }
}
